import { IAssociationsStates, InitialGeneralState } from 'interfaces/general.interface';
import * as GeneralTypes from './general.types';
import {
  ICountryAPIResponseItem,
  IGetExchangesAPIResponseItem,
  IGetPointsOfSaleCategoriesAPIResponseItem,
} from 'api/endpoints/general/general.response.interface';

export type TgeneralDispatchReducer =
  | {
      type: typeof GeneralTypes.SET_PING;
      payload: boolean;
    }
  | {
      type: typeof GeneralTypes.SET_EXCHANGES;
      payload: Array<IGetExchangesAPIResponseItem>;
    }
  | {
      type: typeof GeneralTypes.SET_COUNTRIES;
      payload: Array<ICountryAPIResponseItem>;
    }
  | {
      type: typeof GeneralTypes.SET_ASSOCIATIONS_STATES;
      payload: IAssociationsStates;
    }
  | {
      type: typeof GeneralTypes.SET_POINTS_OF_SALE_CATEGORIES;
      payload: Array<IGetPointsOfSaleCategoriesAPIResponseItem>;
    }
  | {
      type: typeof GeneralTypes.SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES;
      payload: boolean;
    };

export default function generalReducer(
  state: InitialGeneralState,
  action: TgeneralDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case GeneralTypes.SET_PING: {
      const setPing: InitialGeneralState = {
        ...state,
        ping: payload,
        isLoadingSetPing: false,
      };
      return setPing;
    }

    case GeneralTypes.SET_EXCHANGES: {
      const setExchanges: InitialGeneralState = {
        ...state,
        exchanges: payload,
      };
      return setExchanges;
    }

    case GeneralTypes.SET_COUNTRIES:
      const setCountries: InitialGeneralState = {
        ...state,
        countries: payload,
      };
      return setCountries;

    case GeneralTypes.SET_ASSOCIATIONS_STATES: {
      const setAssociationsStates: InitialGeneralState = {
        ...state,
        associationStates: payload,
      };
      return setAssociationsStates;
    }

    case GeneralTypes.SET_POINTS_OF_SALE_CATEGORIES: {
      const setPointsOfSaleCategories: InitialGeneralState = {
        ...state,
        pointsOfSaleCategories: payload,
      };
      return setPointsOfSaleCategories;
    }

    case GeneralTypes.SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES: {
      const setIsLoadingPointsOfSaleCategories: InitialGeneralState = {
        ...state,
        isLoadingPointsOfSaleCategories: payload,
      };
      return setIsLoadingPointsOfSaleCategories;
    }

    default:
      return state;
  }
}
